import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the api
 */
export class DataFilteringService extends BaseService {

	constructor() {	
		super();
	}
	
	async getDataFilters() {
		var data = await this.makeGETRequest('/api/resource/data-filters');		
		return data;		
	}
	
	async getDataFilter(id) {
		var data = await this.makeGETRequest('/api/resource/data-filters/' + id);		
		return data;		
	}
	
	async getDataFieldDefinitions(dataType) {
		var data = await this.makeGETRequest('/api/resource/data-filters/field-definitions/' + dataType);		
		return data;		
	}	
	
	async saveDataFilter(filter, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/data-filters/' + filter.datafilterId, filter);
		} else {
			saved = await this.makePOSTRequest('/api/resource/data-filters', filter);
		}
		return saved;		
	}	
	
	async deleteDataFilter(datafilterId) {
		var data = await this.makeDELETERequest('/api/resource/data-filters/' + datafilterId);		
		return data;		
	}

	async testDataFilter(testRequest) {
		var data = await this.makePOSTRequest('/api/resource/data-filters/test', testRequest);
		return data;
	}
	
}